import { Collapse, Icon, Menu, MenuDivider, MenuItem } from "@blueprintjs/core";
import { Copyright } from "@package/ui-components";
import { type SidebarEntry } from "@package/ui-config";
import { OrganizationSelect } from "@package/ui-organization";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { sidebarEntries } from "../../constants/contants";
import { SidebarMenuItem } from "./SidebarMenuItem";

const SIDEBAR_ENTRIES_ADVANCED: SidebarEntry[] = [sidebarEntries.layout];
const SIDEBAR_ENTRIES_ANALYTICS: SidebarEntry[] = [sidebarEntries.events];

export function Sidebar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isEntryActiveAdvanced = useMemo<boolean>(
    () =>
      SIDEBAR_ENTRIES_ADVANCED.some(
        (entry) => !!pathname?.startsWith(`/${entry.path}`),
      ),
    [pathname],
  );
  const isEntryActiveAnalytics = useMemo<boolean>(
    () =>
      SIDEBAR_ENTRIES_ANALYTICS.some(
        (entry) => !!pathname?.startsWith(`/${entry.path}`),
      ),
    [pathname],
  );

  const [isEntryOpenAdvanced, setIsEntryOpenAdvanced] = useState(
    isEntryActiveAdvanced,
  );
  const [isEntryOpenAnalytics, setIsEntryOpenAnalytics] = useState(
    isEntryActiveAnalytics,
  );

  useEffect(
    function effectEntryActiveAdvanced() {
      setIsEntryOpenAdvanced(isEntryActiveAdvanced);
    },
    [isEntryActiveAdvanced],
  );

  return (
    <div className="flex flex-col h-full">
      <Menu large className="bg-inherit min-w-60 flex-grow">
        <OrganizationSelect onChange={() => navigate("/")} />
        <MenuDivider />
        <SidebarMenuItem entry={sidebarEntries.locations} />
        <SidebarMenuItem entry={sidebarEntries.profiles} />
        <SidebarMenuItem entry={sidebarEntries.posts} />
        <SidebarMenuItem entry={sidebarEntries.tags} />
        <SidebarMenuItem entry={sidebarEntries.media} />
        <SidebarMenuItem entry={sidebarEntries.scheduler} />
        <MenuDivider />
        <MenuItem
          icon="pie-chart"
          labelElement={
            <Icon icon={isEntryOpenAnalytics ? "caret-down" : "caret-right"} />
          }
          text="Analytics"
          onClick={() => setIsEntryOpenAnalytics(!isEntryOpenAnalytics)}
        />
        <Collapse isOpen={isEntryOpenAnalytics}>
          {SIDEBAR_ENTRIES_ANALYTICS.map((entry) => (
            <SidebarMenuItem key={entry.path} entry={entry} />
          ))}
        </Collapse>
        <MenuDivider />
        <MenuItem
          icon="menu"
          labelElement={
            <Icon icon={isEntryOpenAdvanced ? "caret-down" : "caret-right"} />
          }
          text="Advanced"
          onClick={() => setIsEntryOpenAdvanced(!isEntryOpenAdvanced)}
        />
        <Collapse isOpen={isEntryOpenAdvanced}>
          {SIDEBAR_ENTRIES_ADVANCED.map((entry) => (
            <SidebarMenuItem key={entry.path} entry={entry} />
          ))}
        </Collapse>
        <MenuDivider />
      </Menu>
      <div className="mt-6 ml-3 text-xs pb-4">
        <Copyright slim />
      </div>
    </div>
  );
}
